module.exports = __webpack_public_path__ + "static/media/Hyperloop.0eb15d82.png";